/**
 * 异步操作
 */

import * as configs from '@utiles/repairedAccount/config';
import Language from '../languages';

import { post, getJSON } from '../ultile';

Language.init();
const lang = Language.getAll();

/**
 * 获取问题列表
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
export const repairedAccount_fetchQuestList = ({ commit, state }) => {
  let url = configs.BASEURL.passport + configs.API.fetchQuestList;
  let opt = {
    language: state.curLanguage,
    appLanguage: state.curAppLanguage,
  };
  let callback = res => {
    const result = res.result;
    const data = res.data;
    if (result == 1 && data && data.length > 0) {
      commit('repairedAccount_setQuestList', data);
    }
  };
  getJSON(url, opt).then(res => {
    callback(res.res);
  });
};

/**
 * 获取地区列表
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
export const repairedAccount_fetchAreaList = ({ commit, state }) => {
  let url = configs.BASEURL.support + configs.API.fetchAreaList;
  let opt = {
    language: state.curLanguage,
    appLanguage: state.curAppLanguage,
  };
  let callback = res => {
    const result = res.result;
    const data = res.data;
    if (result == 1 && data && data.length > 0) {
      commit('repairedAccount_setAreaList', data);
    }
  };
  getJSON(url, opt).then(res => {
    callback(res.res);
  });
};

/**
 * 申请账号修复
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
export const repairedAccount_apply = (
  { commit, dispatch, state },
  [params, successFn, errorFn]
) => {
  let url = configs.BASEURL.support + configs.API.apply;
  let opt = params;
  let callback = (res, rawRes) => {
    const result = res.result;
    const data = res.data ? res.data : {};
    const msg = res.msg || rawRes.errmsg;
    if (result == 1) {
      data.result = result;
      data.msg = msg || rawRes.errmsg;
      commit('repairedAccount_setCurProcess', 'apply');
      commit('repairedAccount_setApplyResult', data);
      successFn && typeof successFn == 'function' && successFn();
    } else {
      // commit('repairedAccount_setDialogs', msg)
      dispatch('repairedAccount_displayDialog', msg);
      errorFn && typeof errorFn == 'function' && errorFn();
    }
  };
  opt.language = state.curLanguage;
  opt.appLanguage = state.curAppLanguage;
  post(url, opt).then(res => {
    callback(res.res, res);
  });
};

/**
 * 查询账号修复结果
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
export const repairedAccount_query = (
  { commit, dispatch, state },
  [params, fn]
) => {
  let url = configs.BASEURL.support + configs.API.query;
  let opt = params;
  let callback = (res, rawRes) => {
    const result = res.data.result;
    const data = res.data.data ? res.data.data : {};
    // let msg = lang[result] ? lang[result] : res.msg
    let msg = res.data.msg || rawRes.errmsg;
    data.msg = msg;
    data.result = result;
    commit('repairedAccount_setCurProcess', 'query');
    commit('repairedAccount_setQueryResult', data);
    if (
      result == 0 ||
      result == -2 ||
      result == 2 ||
      result == 3 ||
      result == 4 ||
      result == 5 ||
      result == 6 ||
      result == 7
    ) {
      fn && typeof fn == 'function' && fn(res);
    } else {
      // msg = msg ? msg : rawRes.errmsg
      dispatch('repairedAccount_displayDialog', msg);
    }
  };
  opt.language = state.curLanguage;
  opt.appLanguage = state.curAppLanguage;
  post(url, opt).then(res => {
    callback(res.res, res);
  });
};

/**
 * 补充账号修复资料
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
export const repairedAccount_add = (
  { commit, dispatch, state },
  [params, fn]
) => {
  let url = configs.BASEURL.support + configs.API.add;
  let opt = params;
  let callback = (res, rawRes) => {
    const result = res.result;
    const data = res.data ? res.data : {};
    const msg = res.msg || rawRes.errmsg;
    data.msg = msg;
    data.result = result;
    commit('repairedAccount_setCurProcess', 'add');
    commit('repairedAccount_setAddResult', data);
    if (result == 1) {
      fn && typeof fn == 'function' && fn();
    } else {
      // commit('repairedAccount_setDialogs', msg)
      dispatch('repairedAccount_displayDialog', msg);
    }
  };
  opt.language = state.curLanguage;
  opt.appLanguage = state.curAppLanguage;
  post(url, opt, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  }).then(res => {
    callback(res.res, res);
  });
};

/**
 * 发送邮箱验证码
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
export const repairedAccount_sendEmailVerify = (
  { commit, dispatch, state },
  [params, fn]
) => {
  let url = configs.BASEURL.passport + configs.API.sendEmailVerify;
  let opt = params;
  let callback = (res, rawRes) => {
    const result = res.result;
    const data = res.data ? res.data : {};
    const msg = res.msg || rawRes.errmsg;
    data.msg = msg;
    if (result == 1) {
      commit('repairedAccount_setEmailSendStatus', data);
      fn && typeof fn == 'function' && fn();
    } else {
      dispatch('repairedAccount_displayDialog', msg);
    }
  };
  opt.language = state.curLanguage;
  opt.appLanguage = state.curAppLanguage;
  getJSON(url, opt).then(res => {
    callback(res.res, res);
  });
};

/**
 * 重置密码
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
export const repairedAccount_resetPwd = (
  { commit, dispatch, state },
  params
) => {
  let url = configs.BASEURL.passport + configs.API.resetPwd;
  let opt = params;
  // data: ""
  // msg: "decrypt error"
  // result: "0"
  let callback = res => {
    const result = (res.result = parseInt(res.result));
    const msg = res.msg;
    if (result == 1) {
      commit('repairedAccount_setResetPwdStatus', res);
      dispatch('repairedAccount_displayDialog', lang.changePasswordSucc);
    } else {
      dispatch('repairedAccount_displayDialog', msg);
    }
  };
  opt.language = state.curLanguage;
  opt.appLanguage = state.curAppLanguage;
  getJSON(url, opt).then(res => {
    callback(res.res);
  });
};

/**
 * 重置邮箱
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
export const repairedAccount_resetEmail = (
  { commit, dispatch, state },
  params
) => {
  let url = configs.BASEURL.passport + configs.API.resetEmail;
  let opt = params;
  let callback = res => {
    const result = res.result;
    const msg = res.msg;
    if (result == 1) {
      commit('repairedAccount_setResetEmailStatus', res);
      dispatch('repairedAccount_displayDialog', lang.alterSuccess);
    } else {
      dispatch('repairedAccount_displayDialog', msg);
    }
  };
  opt.language = state.curLanguage;
  opt.appLanguage = state.curAppLanguage;
  getJSON(url, opt).then(res => {
    callback(res.res);
  });
};

/**
 * 重置安全问题
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
export const repairedAccount_resetQuest = (
  { commit, dispatch, state },
  params
) => {
  let url = configs.BASEURL.passport + configs.API.resetQuest;
  let opt = params;
  let callback = (res, rawRes) => {
    const result = res.result;
    const msg = res.msg || rawRes.errmsg;
    if (result == 1) {
      commit('repairedAccount_setResetQuestStatus', res);
      dispatch('repairedAccount_displayDialog', lang.questionAlterSuccess);
    } else {
      dispatch('repairedAccount_displayDialog', msg);
    }
  };
  opt.language = state.curLanguage;
  opt.appLanguage = state.curAppLanguage;
  getJSON(url, opt).then(res => {
    callback(res.res, res);
  });
};

/**
 * 重置安全问题
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 //  */
// export const repairedAccount_setUserAccount = ({commit, dispatch}, params) => {
//     let url = configs.BASEURL.support + configs.API.resetQuest
//     let opt = params
//     let callback = (res) => {
//         const result = res.result
//         const msg = lang['resetQuest'][result] ? lang['resetQuest'][result] : res.msg
//         if (result == 1) {
//             commit('repairedAccount_setUserAccount', res)
//         } else {
//             dispatch('repairedAccount_displayDialog', msg)
//         }
//     }
//     utils.ajaxPost(url, opt, callback)
// }

/**
 * 隐藏显示框
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
export const repairedAccount_displayDialog = ({ commit }, text) => {
  commit('repairedAccount_setDialogs', text);
  setTimeout(() => {
    commit('repairedAccount_hideDialogs');
  }, 2000);
};
